import React, { useEffect, useState } from "react";
import { StyleSheet, View, Text } from "react-native";

import Input from "./Input";
import Checkbox from "./Checkbox";
import MaskedInput from "./MaskedInput";

import api from "../../services/api";
import RNPickerSelect from "react-native-picker-select";

export default function ForeignInput({ onValueChange, handleForeign, errors }) {
  const [rg, setRg] = useState("");
  const [countries, setCountries] = useState([]);
  const [passport, setPassport] = useState("");
  const [isForeign, setIsForeign] = useState(false);

  const [nationality, setNationality] = useState({
    label: "Selecionar...",
    value: null,
  });

  useEffect(() => {
    api.get("countries").then(({ data }) => {
      const { data: countries } = data;
      setCountries(
        countries.map((country) => {
          return {
            label: country.name,
            value: country.id,
          };
        })
      );
    });
  }, []);

  return (
    <>
      {!isForeign ? (
        <>
          <MaskedInput
            mask="99.999.999-9"
            keyboardType="numeric"
            label="Digite seu RG"
            value={rg}
            onValueChange={(val) => {
              setRg(val);
              onValueChange("rg", val);
            }}
          />
          {errors.rg ? <Text style={styles.error}>{errors.rg}</Text> : null}
        </>
      ) : (
        <>
          <Input
            name="name"
            value={passport}
            label="Digite seu passaporte"
            onValueChange={(value) => {
              setPassport(value);
              onValueChange("passport", value);
            }}
          />

          {errors.passport ? (
            <Text style={styles.error}>{errors.passport}</Text>
          ) : null}

          <View style={styles.breakpoint}></View>

          <View>
            <Text>Informe sua nacionalidade</Text>

            <RNPickerSelect
              style={{
                inputWeb: {
                  borderRadius: 4,
                  paddingHorizontal: 10,
                  height: 40,
                  marginVertical: 10,
                  color: '#222'
                }
              }}
              placeholder={nationality}
              useNativeAndroidPickerStyle={false}
              onValueChange={(_country) => {
                const selectedCountry =
                  countries[
                  countries.findIndex((country) => country.value == _country)
                  ];

                if (selectedCountry != undefined) {
                  const label = selectedCountry.label;
                  const value = selectedCountry.value;

                  setNationality({ label, value });

                  onValueChange("country_id", value);
                }
              }}
              items={countries}
            />
          </View>

          {errors.country ? (
            <Text style={styles.error}>{errors.country}</Text>
          ) : null}
        </>
      )}

      <Checkbox
        size={20}
        color="#1FBFB5"
        selected={isForeign}
        text="Sou estrangeiro"
        style={styles.checkbox}
        textStyle={styles.checkboxText}
        onPress={(selected) => {
          setIsForeign(selected);
          handleForeign(selected);
        }}
      />
    </>
  );
}

const styles = StyleSheet.create({
  checkbox: {
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    top: 20,
  },
  checkboxText: {
    marginLeft: 15,
    fontSize: 12,
  },
  breakpoint: {
    marginBottom: 15,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: 5
  },
  error: {
    marginTop: 10,
    fontStyle: "italic",
    color: "red",
  },
});
